import React from 'react';
import styles from './TimeModal.module.css';

function ClockFace({ currentDate, handleHourChange }) {
  // Calculate rotation for hour hand (30° per hour + 0.5° per minute)
  const hourRotation = (currentDate.hours % 12) * 30 + (currentDate.minutes * 0.5);
  
  // Calculate rotation for minute hand (6° per minute)
  const minuteRotation = currentDate.minutes * 6;

  return (
    <div className={styles.clockFace}>
      <div className={styles.clockNumbers}>
        {[11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((hour) => (
          <button
            key={hour}
            onClick={() => handleHourChange(hour)}
            aria-label={`Set to ${hour} o'clock`}
            className={`${styles[`number${hour}`]} ${currentDate.hours % 12 === hour % 12 ? styles.active : ''}`}
          >
            {hour}
          </button>
        ))}
      </div>
      <div className={styles.clockCenter} aria-hidden="true" />
      <div
        className={styles.hourHand}
        style={{
          transform: `rotate(${hourRotation}deg)`
        }}
      />
      <div
        className={styles.minuteHand}
        style={{
          transform: `rotate(${minuteRotation}deg)`
        }}
      />
    </div>
  );
}

export default ClockFace;